import { ButtonTypeBlock, ImageTypeBlock, PlainTextBlock, RichMessageBlock } from '../types';

import { buttonValidationBuilder } from './buttonValidationBuilder';
import { imagesValidationBuilder } from './imagesValidationBuilder';
import { plainTextValidatorBuilder } from './plainTextValidationBuilder';
import { richMessageValidationBuilder } from './richMessageValidationBuilder';

type ValidationBuilderReturnType = {
  validatePlainText: (message: PlainTextBlock) => void;
  validateRichMessage: (message: RichMessageBlock) => void;
  validateImages: (message: ImageTypeBlock) => void;
  validateLineMessageButton: (message: ButtonTypeBlock) => void;
  validateLineMessagePreviewButton: (message: ButtonTypeBlock) => void;
};

type ValidationBuilder = (index: number, prefix?: string) => ValidationBuilderReturnType;

export const validationBuilder: ValidationBuilder = (index, prefix) => {
  const validatePlainText = plainTextValidatorBuilder(index);
  const validateRichMessage = richMessageValidationBuilder(index);
  const validateImages = imagesValidationBuilder(index);
  const { validateLineMessageButton, validateLineMessagePreviewButton } = buttonValidationBuilder(
    index,
    prefix
  );

  return {
    validatePlainText,
    validateRichMessage,
    validateImages,
    validateLineMessageButton,
    validateLineMessagePreviewButton,
  };
};
